export const addresses = {
  assetStoreProvider: "0x69f801F34B4e9B7aDF2245FA2B686e0188e505f4",
  coinProvider: "0xA084b3a45044366A6af2C0521f51Ad7948e6C7E2",
  colorSchemes: "0xB602f54f4bFbD45d1452b0fB970726C04090b97E",
  bitcoinArtProvider: "0xEC361A1dbAa28fC36162c65E6b65D9a60138b994",
  bitcoinToken: "0x53611175752d088839c94572498D4A9783a63e02",
};
